import { Box, Button, IconButton, SimpleGrid } from '@chakra-ui/react'
import { RefObject } from 'react'
import BackSpace from '../../components/Icon/BackSpace'
import colors from '../../config/theme/colors'
import useKeys from './useKeys'
import useStorage from '../../hooks/useStorage'

export const numbers = [1, 2, 3, 4, 5, 6, 7, 8, 9]

export default function Keys({
    mode,
    refInput,
    maxValue,
    refRef,
    refLote,
    refForm,
    paymentTypeId
}: {
    mode: string
    refInput: RefObject<HTMLInputElement>
    maxValue: number
    refRef?: any
    refLote?: any
    refForm?: any
    paymentTypeId?: any
}) {
    const { clickNumHandler, eraserHandler, clearHandler } = useKeys(
        mode,
        refInput,
        maxValue
    )
    const { business_variables } = useStorage()
    const isEnabledRefAndLoteDelivery =
        business_variables.find(bv => bv.code === '032')?.value === '1'

    function clickButtonOk() {
        if (!refRef.current || refRef.current?.value == '') {
            refRef.current?.focus()
        } else if (!refLote.current || refLote.current?.value == '') {
            refLote.current?.focus()
        } else {
            if (refRef.current?.value.length < 4) {
                refRef.current.value = refRef.current.value.padStart(4, '0')
            }
            if (refLote.current?.value.length < 4) {
                refLote.current.value = refLote.current.value.padStart(4, '0')
            }
            refForm.current?.requestSubmit()
        }
    }

    return (
        <Box display="flex" justifyContent="center" gridGap={4}>
            <Box>
                <SimpleGrid gap="3" columns={3}>
                    {numbers.map((number: number) => (
                        <Button
                            key={number}
                            w={{ base: '65px', md: '90px' }}
                            h={{ base: '65px', md: '90px' }}
                            variant="gray-3:2xl-lg"
                            bg="transparent"
                            color="gray-2"
                            onClick={() => clickNumHandler(number.toString())}
                        >
                            {number}
                        </Button>
                    ))}
                </SimpleGrid>
                <Box
                    mt="3"
                    display="flex"
                    justifyContent="flex-end"
                    gridGap="3"
                >
                    <Button
                        w={{ base: '65px', md: '90px' }}
                        h={{ base: '65px', md: '90px' }}
                        variant="gray-3:2xl-lg"
                        bg="transparent"
                        color="gray-2"
                        onClick={() => clickNumHandler('0')}
                    >
                        0
                    </Button>
                    <Button
                        w={{ base: '65px', md: '90px' }}
                        h={{ base: '65px', md: '90px' }}
                        variant="gray-3:2xl-lg"
                        bg="transparent"
                        color="gray-2"
                        onClick={() => clickNumHandler('.')}
                    >
                        .
                    </Button>
                </Box>
            </Box>
            <Box display="flex" flexDirection="column" gridGap="3">
                <IconButton
                    aria-label="BackSpaceButton"
                    w={{ base: '65px', md: '90px' }}
                    h={{ base: '65px', md: '90px' }}
                    colorScheme="orange"
                    rounded="lg"
                    onClick={eraserHandler}
                    fontSize={{ base: 'md', md: '2xl' }}
                    icon={<BackSpace fill={colors.white} />}
                ></IconButton>
                <Button
                    w={{ base: '65px', md: '90px' }}
                    h={{ base: '65px', md: '90px' }}
                    colorScheme="orange"
                    rounded="lg"
                    onClick={clearHandler}
                    fontSize={{ base: 'lg', md: '2xl' }}
                >
                    Clear
                </Button>
                {isEnabledRefAndLoteDelivery && paymentTypeId == 2 ? (
                    <Button
                        w={{ base: '65px', md: '90px' }}
                        h={{ base: '65px', md: '90px' }}
                        onClick={() => clickButtonOk()}
                        colorScheme="green"
                        rounded="lg"
                        fontSize={{ base: 'lg', md: '2xl' }}
                    >
                        Ok
                    </Button>
                ) : (
                    <Button
                        w={{ base: '65px', md: '90px' }}
                        h={{ base: '65px', md: '90px' }}
                        type="submit"
                        colorScheme="green"
                        rounded="lg"
                        fontSize={{ base: 'lg', md: '2xl' }}
                    >
                        Ok
                    </Button>
                )}
            </Box>
        </Box>
    )
}
